// export default {
//   login: 'john-smilga',
//   id: 42133389,
//   node_id: 'MDQ6VXNlcjQyMTMzMzg5',
//   avatar_url: 'https://avatars3.githubusercontent.com/u/42133389?v=4',
//   gravatar_id: '',
//   url: 'https://api.github.com/users/john-smilga',
//   html_url: 'https://github.com/john-smilga',
//   followers_url: 'https://api.github.com/users/john-smilga/followers',
//   following_url:
//     'https://api.github.com/users/john-smilga/following{/other_user}',
//   gists_url: 'https://api.github.com/users/john-smilga/gists{/gist_id}',
//   starred_url:
//     'https://api.github.com/users/john-smilga/starred{/owner}{/repo}',
//   subscriptions_url: 'https://api.github.com/users/john-smilga/subscriptions',
//   organizations_url: 'https://api.github.com/users/john-smilga/orgs',
//   repos_url: 'https://api.github.com/users/john-smilga/repos',
//   events_url: 'https://api.github.com/users/john-smilga/events{/privacy}',
//   received_events_url:
//     'https://api.github.com/users/john-smilga/received_events',
//   type: 'User',
//   site_admin: false,
//   name: 'John Smilga',
//   company: 'Coding Addict',
//   blog: 'www.johnsmilga.com',
//   location: 'Los Angeles',
//   email: null,
//   hireable: null,
//   bio: 'Creator of Coding Addict',
//   twitter_username: 'john_smilga',
//   public_repos: 152,
//   public_gists: 0,
//   followers: 1495,
//   following: 0,
//   created_at: '2018-08-06T06:48:23Z',
//   updated_at: '2020-07-08T05:01:32Z',
// };

export default {
  login: 'wujekbizon',
  id: 97871150,
  node_id: 'U_kgDOBdVlLg',
  avatar_url: 'https://avatars.githubusercontent.com/u/97871150?v=4',
  gravatar_id: '',
  url: 'https://api.github.com/users/wujekbizon',
  html_url: 'https://github.com/wujekbizon',
  followers_url: 'https://api.github.com/users/wujekbizon/followers',
  following_url:
    'https://api.github.com/users/wujekbizon/following{/other_user}',
  gists_url: 'https://api.github.com/users/wujekbizon/gists{/gist_id}',
  starred_url: 'https://api.github.com/users/wujekbizon/starred{/owner}{/repo}',
  subscriptions_url: 'https://api.github.com/users/wujekbizon/subscriptions',
  organizations_url: 'https://api.github.com/users/wujekbizon/orgs',
  repos_url: 'https://api.github.com/users/wujekbizon/repos',
  events_url: 'https://api.github.com/users/wujekbizon/events{/privacy}',
  received_events_url:
    'https://api.github.com/users/wujekbizon/received_events',
  type: 'User',
  site_admin: false,
  name: 'Grzegorz Wolfinger',
  company: 'Freelancer',
  blog: 'https://grzegorz-wolfinger-portfoliov2.vercel.app/',
  location: 'Cracow , Poland',
  email: null,
  hireable: null,
  bio: null,
  twitter_username: null,
  public_repos: 27,
  public_gists: 0,
  followers: 1,
  following: 0,
  created_at: '2022-01-17T06:22:42Z',
  updated_at: '2022-07-24T06:55:31Z',
};
